import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';

@Injectable({
  providedIn: 'root'
})
export class CommonUtilService {
	constructor(){}

	isArray(obj : any ) {
	   return Array.isArray(obj)
	}
}